import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

// yesLabel and loading are optional, so existing confirmations look and behave as before
const Confirm = ({ title, children, onCancel = () => {}, onSuccess = () => {}, yesLabel = 'Yes', loading = false }) => {
  return (
    <Modal open={true}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        {children}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel} negative disabled={loading}>No</Button>
        <Button onClick={onSuccess} positive loading={loading} disabled={loading}>{yesLabel}</Button>
      </Modal.Actions>
    </Modal>
  )
}

export default Confirm
